<template>
	<div>
		<div class="tree-table-grid theader" :style="`border-color:${$appColors.gray}`">
			<h4 class="column-title" :style="`color:${$appColors.primary}`">NOMBRE</h4>
			<h4 class="column-title" :style="`color:${$appColors.primary}`">TIPO</h4>
			<h4 class="column-title" :style="`color:${$appColors.primary}`">ACCIONES</h4>
		</div>
		<TreeNodesDl class="tree-node" children="entities" text="name" :indent="12" :nodes="treeData">
			<template slot-scope="{ node, isOpen }">
				<div class="tree-table-grid tbody" :style="`color:${$appColors.info}`">
					<div class="tree-title">
						<app-tooltip-button
							v-if="node.entities.length > 0"
							:icon="isOpen ? 'remove_circle_outline' : 'add_circle_outline'"
							text="Agregar"
							color="primary"
						/>
						<h5>{{ node.name }}</h5>
					</div>
					<span class="tool-type" :style="`border-color:${$appColors.gray}`">{{
						node.entityType.name
					}}</span>
					<div class="tool-action">
						<app-tooltip-button
							icon="add_circle_outline"
							text="Agregar"
							color="primary"
							@click-icon="addItem($event, node, isOpen)"
						/>
						<app-tooltip-button
							:img="`${$imageUrl}/edit.svg`"
							text="Editar"
							@click-icon="editItem($event, node, isOpen)"
						/>
						<app-tooltip-button
							:img="`${$imageUrl}/delete-button.svg`"
							text="Eliminar"
							@click-icon="deleteItem($event, node, isOpen)"
						/>
						<div v-if="node.entityType.number === 2" class="more-options-container">
							<button
								class="more-options-btn"
								@click="toggleMenu($event, node, isOpen)"
							>
								<v-icon>more_vert</v-icon>
							</button>
							<div
								v-if="activeMenuNodeId === node.id"
								class="custom-dropdown"
								:style="dropdownStyle"
							>
								<div
									class="dropdown-item"
									@click="addIndicators($event, node, isOpen)"
								>
									<v-icon>add_circle_outline</v-icon>
									<span>Agregar Indicadores</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</TreeNodesDl>
		<p-confirm-dialog ref="confirmDialog" />
	</div>
</template>

<script>
import TreeNodesDl from 'tree-nodes-dl';
import PConfirmDialog from '@/modules/shared/components/ui/p-confirm-dialog';

function editItem(e, node, isOpen) {
	if (isOpen) {
		e.stopPropagation();
	}
	const { number, name, flagQuestion, id, additionalInformation, description } = node;
	const params = { number, name, flagQuestion, id, additionalInformation, description };
	this.goTo('new-level-form', { params });
}

function addItem(e, node, isOpen) {
	if (isOpen) {
		e.stopPropagation();
	}
	this.openNewLevelForm(node);
}

function addIndicators(e, node, isOpen) {
	if (isOpen) {
		e.stopPropagation();
	}
	const { toolCode, toolId } = this.$route.params;
	const params = {
		nodeId: node.id,
		toolCode,
		toolId,
	};
	this.goTo('development-plan-by-competence', { params });
}

async function deleteItem(e, node, isOpen) {
	if (isOpen) {
		e.stopPropagation();
	}
	this.$refs.confirmDialog.showConfirm({
		onOk: async () => {
			try {
				const { toolCode } = this.$route.params;
				const hierarchyFatherId = node.id;
				const firstResponse = await this.$http.delete(`hierarchies/${hierarchyFatherId}/${toolCode}`);
				if (firstResponse && firstResponse.status === 200) {
					if (node.competenceIndicator && node.competenceIndicator.id) {
						await this.$http.delete(`competence-indicator/${node.competenceIndicator.id}`);
					}
					this.showNotification('Registro eliminado correctamente.');
					this.$emit('delete-item');
				}
			} catch (error) {
				this.showGenericError();
			}
		},
		title: '¿Seguro que desea eliminar de la lista?',
	});
}

function openNewLevelForm(node) {
	const params = { number: node.number, hierarchyFatherId: node.id };
	this.goTo('new-level-form', { params });
}

function data() {
	return {
		activeMenuNodeId: null,
		dropdownPosition: { top: '0px', left: '0px' },
	};
}

function toggleMenu(e, node, isOpen) {
	if (isOpen) {
		e.stopPropagation();
	}
	if (this.activeMenuNodeId === node.id) {
		this.activeMenuNodeId = null;
	} else {
		this.activeMenuNodeId = node.id;
		const rect = e.target.getBoundingClientRect();
		this.dropdownPosition = {
			top: `${rect.bottom + 4}px`,
			left: `${rect.left - 100}px`,
		};
	}
}

function mounted() {
	document.addEventListener('click', this.handleClickOutside);
}

function beforeDestroy() {
	document.removeEventListener('click', this.handleClickOutside);
}

function handleClickOutside(e) {
	if (!e.target.closest('.more-options-container')) {
		this.activeMenuNodeId = null;
	}
}

export default {
	name: 'tree-tool-table',
	components: {
		TreeNodesDl,
		PConfirmDialog,
	},
	data,
	mounted,
	beforeDestroy,
	methods: {
		addItem,
		addIndicators,
		editItem,
		deleteItem,
		openNewLevelForm,
		toggleMenu,
		handleClickOutside,
	},
	computed: {
		dropdownStyle() {
			return {
				top: this.dropdownPosition.top,
				left: this.dropdownPosition.left,
			};
		},
	},
	props: {
		treeData: {
			required: true,
			type: Array,
		},
	},
};
</script>
<style lang="scss" scoped>
.theader {
	border-bottom: 1px solid;
	border-top: 1px solid;
	padding: 8px 0;
}

.tree-table-grid {
	align-items: center;
	display: grid;
	grid-template-columns: 1fr 150px 180px;

	.column-title {
		font-family: font(bold);
		text-align: center;
	}

	.tree-title {
		align-items: center;
		display: flex;
	}
}

.tree-node {
	.tbody {
		padding-left: 15px;
	}

	.tool-type {
		border-left: 1px solid;
		border-right: 1px solid;
		padding: 10px 0;
		padding-left: 10px;
	}

	.tool-action {
		align-items: center;
		display: flex;
		justify-content: center;
	}

	.tool-action {
		align-items: center;
		display: flex;
		justify-content: space-evenly;
	}
}

.more-options-container {
	position: relative;
	margin-left: 4px;
	margin-right: 4px;
}

.more-options-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border: none;
	background: transparent;
	cursor: pointer;
	border-radius: 50%;
	transition: all 0.2s ease;

	&:hover {
		background-color: rgba(0, 0, 0, 0.08);
	}

	::v-deep .v-icon {
		color: var(--app-color-gray);
		font-size: 22px;
	}

	&:hover ::v-deep .v-icon {
		color: var(--app-color-primary);
	}
}

.custom-dropdown {
	position: fixed;
	background-color: white;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	min-width: 200px;
	z-index: 1000;
	overflow: hidden;
	border: 1px solid rgba(0, 0, 0, 0.08);

	.dropdown-item {
		display: flex;
		align-items: center;
		padding: 12px 16px;
		cursor: pointer;
		transition: all 0.2s ease;
		font-size: 14px;
		font-weight: 500;
		color: rgba(0, 0, 0, 0.87);

		&:hover {
			background-color: rgba(0, 0, 0, 0.04);
		}

		::v-deep .v-icon {
			color: var(--app-color-primary);
			font-size: 20px;
			margin-right: 12px;
		}
	}
}
</style>

<style lang="scss">
.custom-dropdown .dropdown-item .v-icon {
	color: var(--app-color-primary) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/tools/tree-tool-table.vue